import { useState } from 'react';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { Link } from 'react-router-dom';

const values = [
  { icon: 'ri-shield-check-line', title: '权威可信', desc: '内容严谨、来源清晰，坚持客观中立地呈现黄金市场信息。' },
  { icon: 'ri-time-line', title: '及时更新', desc: '行情数据多时段更新，资讯紧跟市场热点，助你把握第一时间。' },
  { icon: 'ri-book-open-line', title: '专业易懂', desc: '用通俗语言解读专业内容，让不同经验的投资者都能轻松理解。' },
  { icon: 'ri-focus-3-line', title: '聚焦黄金', desc: '围绕黄金现货、期货与投资策略，做深做透黄金这一件事。' },
];

const stats = [
  { value: '10+', label: '行情品种' },
  { value: '每日', label: '资讯更新' },
  { value: '4', label: '内容栏目' },
  { value: '100%', label: '演示数据标注' },
];

export default function About() {
  const [copied, setCopied] = useState(false);
  const email = 'service@gold.example.com';

  const copyEmail = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(email).catch(() => undefined);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Layout>
      <title>关于我们 - 黄金</title>
      <meta name="description" content="了解「黄金」平台：我们聚焦黄金价格行情、市场分析与投资资讯，致力于提供权威、及时、专业的黄金投资信息，帮助投资者科学把握机会。" />
      <meta name="keywords" content="关于黄金,黄金平台,黄金投资信息,黄金行情网站" />

      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-portal px-4 py-6 md:px-6">
          <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">关于我们</h1>
          <div className="mt-3">
            <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />
          </div>
        </div>
      </div>

      <div className="bg-secondary-900">
        <div className="mx-auto max-w-portal px-4 py-14 md:px-6 md:py-16">
          <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
            <div>
              <span className="text-xs font-semibold uppercase tracking-[0.25em] text-primary-400">Our Brand</span>
              <h2 className="mt-3 font-heading text-3xl font-bold text-background-50 md:text-4xl">
                黄金 · 权威黄金行情与投资指导平台
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-secondary-200 md:text-base">
                「黄金」是一个聚焦黄金价格行情、市场分析与投资资讯的专业信息平台。我们面向关注贵金属投资的个人投资者、
                理财顾问及财经研究人员，持续提供权威、及时、专业的黄金行情数据与深入的投资指导内容。
              </p>
              <p className="mt-4 text-sm leading-relaxed text-secondary-300 md:text-base">
                我们的目标很简单：把复杂多变的黄金市场，整理成清晰、可信、易读的信息，帮助你更高效地做出投资判断。
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link
                  to="/category/gold-price"
                  className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400 whitespace-nowrap"
                >
                  浏览黄金行情
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
                <Link
                  to="/category/investment-news"
                  className="inline-flex items-center gap-1.5 rounded-md border border-secondary-600 px-5 py-2.5 text-sm font-medium text-background-100 transition-colors hover:border-primary-400 hover:text-primary-300 whitespace-nowrap"
                >
                  阅读投资资讯
                </Link>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat) => (
                <div key={stat.label} className="rounded-lg border border-secondary-700 bg-secondary-800 p-6 text-center">
                  <div className="font-heading text-3xl font-black text-primary-400">{stat.value}</div>
                  <div className="mt-2 text-sm text-secondary-300">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-portal px-4 py-14 md:px-6 md:py-16">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-primary-700">Our Values</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">服务宗旨与内容定位</h2>
          <p className="mt-2 text-sm text-foreground-600">以专业与诚信为本，让黄金投资信息更简单可信</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((value) => (
            <div key={value.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-2xl text-primary-700">
                <i className={value.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{value.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <i className="ri-mail-send-line text-primary-600" aria-hidden="true"></i>
              联系方式与反馈
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              如果你对内容有建议，或希望补充某个黄金投资话题，欢迎通过邮箱与我们联系。我们会认真阅读每一封来信。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <span className="rounded-md bg-background-100 px-4 py-2.5 text-sm font-medium text-foreground-800">
                {email}
              </span>
              <button
                type="button"
                onClick={copyEmail}
                className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400 whitespace-nowrap cursor-pointer"
              >
                <i className={copied ? 'ri-check-line' : 'ri-file-copy-line'} aria-hidden="true"></i>
                {copied ? '邮箱已复制' : '复制邮箱'}
              </button>
            </div>
            <p className="mt-4 text-xs text-foreground-400">工作日 09:00 - 18:00 · 我们通常在 1-2 个工作日内回复</p>
          </div>

          <div className="rounded-lg border border-primary-200 bg-primary-50 p-6 md:p-8">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-primary-900">
              <i className="ri-error-warning-line" aria-hidden="true"></i>
              免责声明与版权
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-primary-900/90">
              本站所展示的黄金行情数据、价格走势图及分析内容均为演示样例，不构成任何形式的投资建议或收益承诺。
              黄金及贵金属投资存在市场风险，请以官方权威渠道发布的实时数据为准，并独立判断、谨慎决策，据此操作风险自担。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-primary-900/90">
              本站原创内容版权归「黄金」所有，未经许可不得用于商业用途。引用站内内容请注明来源。
            </p>
            <p className="mt-4 text-xs text-primary-800/80">© 2026 黄金 GOLD · 保留所有权利</p>
          </div>
        </div>
      </div>
    </Layout>
  );
}